import React from "react";

export default function AccountDashboard() {
  return (
    <div style={{ padding: 20 }}>
      <h1>Account Dashboard</h1>
      <p>Welcome Accounts Team! Your financial tools will appear here.</p>
    </div>
  );
}
